import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  type ReactNode,
} from "react";

type CarouselVisibilityContextType = {
  isVisible: (index: number) => boolean;
  visibleIndices: Set<number>;
};

const CarouselVisibilityContext =
  createContext<CarouselVisibilityContextType | null>(null);

type Props = {
  children: ReactNode;
  visibleIndices: Set<number>;
};

export const CarouselVisibilityProvider = ({
  children,
  visibleIndices,
}: Props) => {
  const isVisible = useCallback(
    (index: number) => visibleIndices.has(index),
    [visibleIndices]
  );

  const contextValue = useMemo(
    () => ({ visibleIndices, isVisible }),
    [visibleIndices, isVisible]
  );

  return (
    <CarouselVisibilityContext.Provider value={contextValue}>
      {children}
    </CarouselVisibilityContext.Provider>
  );
};

export const useCarouselVisibility = () => {
  const context = useContext(CarouselVisibilityContext);
  if (!context) {
    throw new Error(
      "useCarouselVisibility must be used within a CarouselVisibilityProvider"
    );
  }
  return context;
};
